import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsNotificationTypesLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} notificationType
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsNotificationTypesLinkState */

/**
 * @extends {ShapeComponent<ComponentsNotificationTypesLinkProps, ComponentsNotificationTypesLinkState>}
 */
class ComponentsNotificationTypesLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    notificationType: instanceOfClassName("NotificationType").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, notificationType, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--notification-types--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || notificationType.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || notificationType.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, notificationType} = this.p

    if (adminLayout) return Routes.adminNotificationTypePath(notificationType.id())
  }
}

export default memo(shapeComponent(ComponentsNotificationTypesLink))
